"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEqualHelper = exports.mapValueToArray = exports.findValueInArray = exports.groupArrayValuesBy = exports.getUniqueArrayValues = exports.getObjectContentValue = void 0;
const getTag = (value) => {
    if (value == null) {
        return value === undefined ? '[object Undefined]' : '[object Null]';
    }
    return toString.call(value);
};
const isKey = (value, object) => {
    const reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
    const reIsPlainProp = /^\w*$/;
    if (Array.isArray(value)) {
        return false;
    }
    const type = typeof value;
    if (type === 'number' || type === 'boolean' || value == null || isSymbol(value)) {
        return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || (object != null && value in Object(object));
};
const charCodeOfDot = '.'.charCodeAt(0);
const reEscapeChar = /\\(\\)?/g;
const rePropName = RegExp('[^.[\\]]+' +
    '|' +
    '\\[(?:' +
    '([^"\'][^[]*)' +
    '|' +
    '(["\'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2' +
    ')\\]' +
    '|' +
    '(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))', 'g');
const stringToPath = (string) => {
    const result = [];
    if (string.charCodeAt(0) === charCodeOfDot) {
        result.push('');
    }
    string.replace(rePropName, (match, expression, quote, subString) => {
        let key = match;
        if (quote) {
            key = subString.replace(reEscapeChar, '$1');
        }
        else if (expression) {
            key = expression.trim();
        }
        result.push(key);
    });
    return result;
};
const castPath = (value, object) => {
    if (Array.isArray(value)) {
        return value;
    }
    return isKey(value, object) ? [value] : stringToPath(value);
};
const isSymbol = (value) => {
    const type = typeof value;
    return type === 'symbol' || (type === 'object' && value != null && getTag(value) === '[object Symbol]');
};
const toKey = (value) => {
    const INFINITY = 1 / 0;
    if (typeof value === 'string' || isSymbol(value)) {
        return value;
    }
    const result = `${value}`;
    return result === '0' && 1 / value === -INFINITY ? '-0' : result;
};
const getNestedObj = (obj, arr) => {
    if (arr.length === 0) {
        return obj;
    }
    const key = toKey(arr[0]);
    const remainingPath = arr.slice(1);
    const objTemp = obj[key];
    return objTemp != null ? getNestedObj(objTemp, remainingPath) : undefined;
};
const baseGet = (object, path) => {
    const castedPath = castPath(path, object);
    return getNestedObj(object, castedPath);
};
const getObjectContentValue = (object, path, defaultValue) => {
    const result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
};
exports.getObjectContentValue = getObjectContentValue;
const getUniqueArrayValues = (array, iteratee) => {
    const uniqueKeys = new Set();
    const keyExtractor = typeof iteratee === 'function' ? iteratee : (item) => item === null || item === void 0 ? void 0 : item[iteratee];
    return array === null || array === void 0 ? void 0 : array.filter((item) => {
        const key = keyExtractor(item);
        if (uniqueKeys.has(key)) {
            return false;
        }
        uniqueKeys.add(key);
        return true;
    });
};
exports.getUniqueArrayValues = getUniqueArrayValues;
const groupArrayValuesBy = (array, iteratee) => {
    return array === null || array === void 0 ? void 0 : array.reduce((result, value) => {
        let key;
        if (typeof iteratee === 'function') {
            key = iteratee(value);
        }
        else if (typeof iteratee === 'string') {
            key = value[iteratee];
        }
        else {
            key = value;
        }
        (result[key] = result[key] || []).push(value);
        return result || [];
    }, {});
};
exports.groupArrayValuesBy = groupArrayValuesBy;
const findValueInArray = (array, predicate, fromIndex = 0) => {
    var _a;
    return (_a = array === null || array === void 0 ? void 0 : array.slice(fromIndex)) === null || _a === void 0 ? void 0 : _a.find((element) => element != null && predicate(element));
};
exports.findValueInArray = findValueInArray;
const mapValueToArray = (collection, iteratee) => {
    const mappedCollection = (collection || []).map((value, index) => {
        if (typeof iteratee === 'function') {
            return iteratee(value, index, collection);
        }
        if (typeof iteratee === 'string') {
            const key = iteratee;
            return value ? value[key] : undefined;
        }
        return {};
    });
    return mappedCollection || [];
};
exports.mapValueToArray = mapValueToArray;
const isEqualHelper = (object, other) => {
    if (object === other) {
        return true;
    }
    if (typeof object !== typeof other || Array.isArray(object) !== Array.isArray(other)) {
        return false;
    }
    if (Array.isArray(object)) {
        return (object.length === other.length && object.every((value, index) => (0, exports.isEqualHelper)(value, other[index])));
    }
    const objectKeys = Object.keys(object);
    const otherKeys = Object.keys(other);
    return (objectKeys.length === otherKeys.length &&
        objectKeys.every(key => other.hasOwnProperty(key) && (0, exports.isEqualHelper)(object[key], other[key])));
};
exports.isEqualHelper = isEqualHelper;
//# sourceMappingURL=ObjectsAndArraysHelpers.js.map